import { createListenerMiddleware } from '@reduxjs/toolkit';

import {
  chatConnectionDetails_WS,
  newChatApprovedMessages_WS,
  newChatMessages_WS,
  newChatPendingMessages_WS,
  newChatRejectedMessages_WS,
} from './actions';
import {
  connectionDetailsEffect,
  newApprovedMessagesEffect,
  newMessagesEffect,
  newPendingMessageEffect,
  newRejectedMessagesEffect,
} from './effects';

import type { RootState } from 'store';

export const chatListener = createListenerMiddleware<RootState>();

chatListener.startListening({
  actionCreator: newChatMessages_WS,
  effect: newMessagesEffect,
});

chatListener.startListening({
  actionCreator: newChatPendingMessages_WS,
  effect: newPendingMessageEffect,
});

chatListener.startListening({
  actionCreator: newChatApprovedMessages_WS,
  effect: newApprovedMessagesEffect,
});

chatListener.startListening({
  actionCreator: newChatRejectedMessages_WS,
  effect: newRejectedMessagesEffect,
});

chatListener.startListening({
  actionCreator: chatConnectionDetails_WS,
  effect: connectionDetailsEffect,
});
